import "office-ui-fabric-react/dist/css/fabric.min.css";
import "./taskpane.css";
import { hot } from "react-hot-loader/root";
import { initializeIcons } from "office-ui-fabric-react/lib/Icons";
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./components/App";

initializeIcons();

/* Keep isOfficeInitialized on the window so HMR re-execution doesn't reset it */
const w = window as Window & { __luppOfficeInitialized?: boolean };
if (w.__luppOfficeInitialized === undefined) {
  w.__luppOfficeInitialized = false;
}

const title = "Lupp AI für Word";

const render = (): void => {
  const HotApp = hot(App);
  ReactDOM.render(
    <HotApp title={title} isOfficeInitialized={w.__luppOfficeInitialized} />,
    document.getElementById("container")
  );
};

// Office.initialize is kept (rather than Office.onReady) for HMR compatibility:
// on module hot-reload, Office.initialize is reassigned and called again,
// which ensures isOfficeInitialized stays in sync without a page reload.
// eslint-disable-next-line office-addins/no-office-initialize
Office.initialize = (): void => {
  w.__luppOfficeInitialized = true;
  render();
};

render();
